module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/customers/customers.component.css
// module id = ./src/app/customers/customers.component.css
// module chunks = main